import React, { useState } from "react";
import { FormGroup, Label, Input, FormFeedback, Button } from "reactstrap";

const PasswordField = ({ validation, name, label, placeholder }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <FormGroup>
            <Label for={name}>{label}</Label>
            <div className="d-flex align-items-center">
                <Input
                    type={showPassword ? "text" : "password"}
                    id={name}
                    name={name}
                    value={validation.values?.[name]}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    placeholder={placeholder}
                    invalid={
                        validation?.touched?.[name] && validation?.errors?.[name] ? true : false
                    }
                />
                <Button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="ms-2"
                    size="sm"
                >
                    {showPassword ? "Hide" : "Show"}
                </Button>
            </div>
            {validation?.touched?.[name] && validation?.errors?.[name] ? (
                <FormFeedback type="invalid">{validation?.errors?.[name]}</FormFeedback>
            ) : null}
        </FormGroup>
    );
};

export default PasswordField;